import {
  CMSMetadata,
  PageId,
  Placement,
  Provider,
  Slot,
} from '@amzn/fire-tv-campaign-automation-service';
import { createContext } from 'react';
import { CMSConfig } from 'src/configs/campaignMetadataConfig';
import { StateConstants } from 'src/constants';

export interface CampaignMetadataContextValue {
  metadata: CMSMetadata;
  updateMetadata: (updates: Partial<CMSMetadata>) => void;
}

/**
 * Creates a default CMS metadata object with configurable dates
 * @param startDate - Optional start date for the campaign (defaults to current date)
 * @param endDate - Optional end date for the campaign (defaults to current date)
 * @returns A CMSMetadata object with default values
 */
export const getDefaultCMSMetadata = (
  startDate = new Date(),
  endDate = new Date(),
): CMSMetadata => ({
  accessibilityText: StateConstants.EMPTY_STRING,
  businessGroupId: CMSConfig?.BUSINESS_GROUP_IDS?.[0],
  campaignStartDate: startDate,
  campaignEndDate: endDate,
  clickThrough: StateConstants.EMPTY_STRING,
  pageId: PageId.HOME_ROT_APPS,
  pageType: CMSConfig?.PAGE_TYPES?.[0],
  placement: Placement.FEATURE_ROTATOR,
  provider: Provider.CAPE,
  slotName: Slot.GRID_1,
  title: StateConstants.EMPTY_STRING,
  locale: CMSConfig?.LOCALE?.[CMSConfig.MARKET_PLACE[0]]?.[0],
});

export const CampaignMetadataContext = createContext<CampaignMetadataContextValue>({
  metadata: getDefaultCMSMetadata(),
  updateMetadata: () => {},
});
